import React from 'react';

import {Modal, Button, ProgressBar} from 'react-bootstrap';

import _ from 'lodash';


const MessageModal = (props) => {

  const type=props.type || 'error';
  const title = {
    'error': 'Oops!',
    'info': 'Information',
    'success': 'Voila!!'
  };

  const hideHandler = () => {
    props.onHide();    
  }
  
  return <Modal show onHide={hideHandler} centered>
  <Modal.Header closeButton>
    <Modal.Title>{props.title ? props.title : title[type]}</Modal.Title>
  </Modal.Header>
  <Modal.Body className="pink-grad-bg text-center">
    <ul className="msg-modal-ul">
      {_.isArray(props.message) && props.message.map((e,i) => <li key={i} className={`text-dark `}>{e}</li>)}
      {_.isString(props.message) && <li className="text-dark">{props.message}</li>}
      {props.dwn && <ProgressBar className="mt-2" animated variant="warning" now={100} />}
    </ul>
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={hideHandler}>Close</Button>
  </Modal.Footer>
</Modal>
}

export default MessageModal;